import styled, { css } from 'styled-components';

export const SvgContainer = styled('svg')`
  position: absolute;
  left: 0;
  right: 0;
`;

export interface LabelGroupProps {
  variant?: 'active' | 'dark' | 'normal';
}
export const labelGroupStyles = css<LabelGroupProps>`
  ${({ variant }) => variant === 'dark' && 'opacity: 0.5;'}
`;

export const ValueLabelGroup = styled('g')<LabelGroupProps>`
  ${({ variant }) => variant !== 'active' && 'transform: translate(0%, 2%)'};
  ${labelGroupStyles}
`;

export const DividendLabelGroup = styled('g')<LabelGroupProps>`
  ${({ variant }) =>
    variant !== 'active'
      ? 'transform: translate(4.4%, -1.7%) rotate(0.4deg)'
      : 'rotate(0.4deg)'};
  ${labelGroupStyles}
`;

export const FutureLabelGroup = styled('g')<LabelGroupProps>`
  ${({ variant }) => variant !== 'active' && 'transform: translate(-4%, -1%)'};
  ${labelGroupStyles}
`;

export const HealthLabelGroup = styled('g')<LabelGroupProps>`
  ${({ variant }) => variant !== 'active' && 'transform: translate(3%, -5%)'};
  ${labelGroupStyles}
`;

export const PastLabelGroup = styled('g')<LabelGroupProps>`
  ${({ variant }) =>
    variant !== 'active' && 'transform: translate(-2.3%, -5.6%)'};
  ${labelGroupStyles}
`;

export const Path = styled('path')`
  fill: ${({ theme }) => theme.color.white};
`;
